const radConfig = {
  allottement_status: false,
  currentUrl: "https://gtr.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://gtr.aikenist.com/api/quickrad",
  baseUrlRadio: "https://gtr.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://gtr.aikenist.com/aikenviewer/viewer/",
  abdmBaseUrl: "https://abdm.aikenist.com",
  viewer3DURL:"https://gtr.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://gtr.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://gtr.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",
  viewerSeg:"https://gtr.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",
  viewerECG: "https://gtr.aikenist.com/3daikenviewer/ecg?StudyInstanceUIDs=",
  viewerMultiple: "https://gtr.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://gtr.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://gtr.aikenist.com/?study=",
  thumbnailURL: "https://gtr.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://gtr.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://gtr.aikenist.com/dicom-web",
  weasisDicomWeb: "https://gtr.aikenist.com/dicom-web",
  studyList: "https://gtr.aikenist.com/dicom-web/studies",
  localViewer: "https://gtr.aikenist.com/aikenviewer/local",
  client: "gtr",
  paymentComplete: true,
  version: "v2.0",
  metabaseSiteUrl: "https://metabase.aikenist.com",
  metabaseDashboardId: 2,
  metabaseEmbedSecret: "dc6f5251fdbedfe7884946ce6637cf337639e5eafb07ffebcb62bf197493185b",
  metabaseUseLockedParams: true,
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
